import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    radio: {
        position: 'relative',
        top: -theme.spacing(),
    },
    group: {
        marginTop: theme.spacing(3),
    },
}));

export const MethodForm = ({ values, onChange }) => {
    const classes = useStyles();

    return (
        <>
            <Typography>
                How would you like to receive your security codes?
            </Typography>
            <RadioGroup value={values.method} onChange={onChange}>
                <FormControlLabel
                    value="sms"
                    className={classes.group}
                    control={<Radio className={classes.radio} />}
                    label={
                        <>
                            <Typography>SMS text message</Typography>
                            <Typography color="textSecondary">
                                Your security codes will be sent to your mobile
                                phone.
                            </Typography>
                        </>
                    }
                />
                <FormControlLabel
                    value="totp"
                    className={classes.group}
                    control={<Radio className={classes.radio} />}
                    label={
                        <>
                            <Typography>Authenticator app</Typography>
                            <Typography color="textSecondary">
                                Your codes will be generated by an authenticator
                                app.
                            </Typography>
                        </>
                    }
                />
            </RadioGroup>
        </>
    );
};
